import { take, takeEvery } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { readyAction } from 'modules/root/actions'
import { runQueuedUploads } from 'modules/storage'
import { onlineStateChange } from 'modules/database/actions'

function handleOnlineStatusChanged(action: ReturnType<typeof onlineStateChange>) {
	if (action.payload) {
		runQueuedUploads()
	}
}

/** The saga function for this module that is run from our root saga. */
export default function* storageSagas(): SagaIterator {
	yield take(readyAction)

	runQueuedUploads()

	yield takeEvery(onlineStateChange, handleOnlineStatusChanged)
}
